import { render } from "./P2PChat.vue?vue&type=template&id=bee1ba76&scoped=true"
import script from "./P2PChat.vue?vue&type=script&lang=js"
export * from "./P2PChat.vue?vue&type=script&lang=js"

import "./P2PChat.vue?vue&type=style&index=0&id=bee1ba76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee1ba76"]])

export default __exports__